// @ts-nocheck
import React, { createRef } from "react";
import NormalSpin from "../../../../base/basicComponents/spin";
import {
  handleUpdateReviseSortFile,
  reviseUpdateSortFilesFollowFileTag,
  actions,
} from "../../../publicDictionaryValues";
import CreateNewProcedureProcess from "../createNewProcedureProcess";
import styles from "../style/index.module.scss";
import ApproveUpdateProcedureComplete from "./approveUpdateProcedureComplete";
import ApproveUpdateProcedurePending from "./approveUpdateProcedurePending";
import ReviseUpdateProcedureComplete from "./reviseUpdateProcedureComplete";
import ReviseUpdateProcedurePending from "./reviseUpdateProcedurePending";
import SubmitUpdateProcedureComplete from "./submitUpdateProcedureComplete";
import AppSetting from "config/AppSetting";

const user = AppSetting.localStorageValue.user.get();
const procedureReplaceFileRef = createRef();
const procedureRef = createRef();
const procedureServerPathRef = createRef();
const procedureSavedInRef = createRef();
const approvePageRef = createRef();
const revisionInfoRef = createRef();
const levelCRef = createRef();
export default class UpdateProcedureProcess extends CreateNewProcedureProcess {
  /* sort procedure files follow status in revise page */
  handleSortFile = (result: any) => {
    const tiggerTimes = result.sequence;
    let isRevise = false;
    if (
      result.workflowProcessStepInfo !== null &&
      result.workflowProcessStepInfo.annotations.length !== 0
    ) {
      isRevise =
        result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
          .value === "1";
    }
    if (tiggerTimes > 1) {
      return handleUpdateReviseSortFile(
        result.procedureFolder?.procedureFiles,
        this._formateDate,
        isRevise
      );
    }
    // @ts-ignore
    return reviseUpdateSortFilesFollowFileTag(
      result.procedureFolder?.procedureFiles,
      this._formateDate
    );
  };

  /**
   * Change update attachment loading ui
   * @param {*} fileLoading
   */
  updateFileNumLoading = (fileLoading: any) => {
    this.setState({
      fileLoading: fileLoading,
      pageState: {
        ...this.state.pageState,
        loading: fileLoading.allNum !== fileLoading.currentNum,
      },
    });
  };

  handleUpdateProcedureProcessPageProps = () => {
    const {
      receiveDate,
      requestByName,
      procedureStatus,
      rejectStatus,
      currentRole,
      procedureAccountID,
      flowCategoryID,
    } = this.state.pageState;

    return {
      receiveDate,
      requestByName,
      procedureStatus,
      rejectStatus,
      currentRole,
      procedureReplaceFileRef,
      procedureAccountID,
      flowCategoryID,
    };
  };

  handleUpdateProcedureProcessSectionProps = () => {
    const { taskInfoData, procedureInfoData } = this.state;

    return {
      taskInfoData,
      procedureInfoData,
      ppoList: this.state.ppoList,
    };
  };

  handleUpdateProcedureProcessSavedInProps = () => {
    const {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
      isSavedInSectionChange,
    } = this.state.savedInSectionState;

    return {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
      // @ts-ignore
      initSavedInStatus: this.initSavedInSectionState.procedureSaveInCategoryStatusID,
      // @ts-ignore
      savedInReturnReasonLog: this.savedInReturnReasonLog,
      isSavedInSectionChange,
    };
  };

  handleUpdateProcedureProcessServerPathProps = () => {
    const {
      clientServerPathStatusName,
      serverPathReturnReasonValue,
      serverPathReasonStatus,
      serverPathReturnReasonInputValue,
      clientServerPathStatusID,
      serverPathValue,
      isServerPathSectionChange,
    } = this.state.serverPathSectionState;

    return {
      clientServerPathStatusName,
      serverPathReturnReasonValue,
      serverPathReasonStatus,
      serverPathReturnReasonInputValue,
      // @ts-ignore
      serverPathReturnReasonLog: this.serverPathReturnReasonLog,
      clientServerPathStatusID,
      serverPathValue,
      isServerPathSectionChange,
    };
  };

  handleUpdateProcedureProcessParams = () => {
    return {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
      // @ts-ignore
      ProcedureFileStepID: this.procedureFileStepID,
      // @ts-ignore
      WorkflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      FlowCategoryID: this.flowCategoryID,
    };
  };

  handleUpdateProcedureProcessReviseUpdateProcedurePending = (procedureTableData: any) => {
    const { shareTaskData, supportingTableData, revisionInfoState } = this.state;

    return (
      // @ts-ignore
      <ReviseUpdateProcedurePending
        pageProps={{
          ...this.handleUpdateProcedureProcessPageProps(),
          isDisableAll: false,
        }}
        sectionProps={this.handleUpdateProcedureProcessSectionProps()}
        savedInProps={this.handleUpdateProcedureProcessSavedInProps()}
        serverPathProps={this.handleUpdateProcedureProcessServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        initRevisionInfoState={(this as any).initRevisionInfoState}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        data={procedureTableData}
        params={this.handleUpdateProcedureProcessParams()}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        updateFileNumLoading={this.updateFileNumLoading}
        returnFileDataValue={(this as any).returnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        supportingTableData={supportingTableData}
        revisionInfoData={revisionInfoState}
        procedureRef={procedureRef}
        procedureServerPathRef={procedureServerPathRef}
        levelCRef={levelCRef}
        revisionInfoRef={revisionInfoRef}
        procedureSavedInRef={procedureSavedInRef}
        shareTaskData={shareTaskData}
        sortDataList={(this as any).sortDataList}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        closePage={this.closePage}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
        isLevelCChange={(this as any).isLevelCChange}
        clientServerJB={(this as any).clientServerJB}
        procedureStatusJB={(this as any).procedureStatusJB}
      />
    );
  };

  handleUpdateProcedureProcessReviseUpdateProcedureComplete = (procedureTableData: any) => {
    const { shareTaskData, supportingTableData, revisionInfoState } = this.state;

    return (
      // @ts-ignore
      <ReviseUpdateProcedureComplete
        pageProps={{
          ...this.handleUpdateProcedureProcessPageProps(),
          isDisableAll: true,
        }}
        sectionProps={this.handleUpdateProcedureProcessSectionProps()}
        savedInProps={this.handleUpdateProcedureProcessSavedInProps()}
        serverPathProps={this.handleUpdateProcedureProcessServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        data={procedureTableData}
        params={this.handleUpdateProcedureProcessParams()}
        procedureRef={procedureRef}
        shareTaskData={shareTaskData}
        sortDataList={(this as any).sortDataList}
        supportingTableData={supportingTableData}
        revisionInfoData={revisionInfoState}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        levelCRef={levelCRef}
        revisionInfoRef={revisionInfoRef}
        _showLoading={this._showLoading}
        returnFileDataValue={(this as any).returnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        closePage={this.closePage}
        _hideLoading={this._hideLoading}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
      />
    );
  };

  handleUpdateProcedureProcessApproveUpdateProcedurePending = (
    procedureTableData: any,
    newRejectReason: any
  ) => {
    const { shareTaskData, supportingTableData, revisionInfoState } = this.state;
    const { excludedReviewersList = [] } = this.state.pageState;

    return (
      // @ts-ignore
      <ApproveUpdateProcedurePending
        ref={approvePageRef}
        approvePageRef={approvePageRef}
        pageProps={{
          ...this.handleUpdateProcedureProcessPageProps(),
          newRejectReason,
          // @ts-ignore
          actionID: this.actionID,
          isDisableAll: false,
          isDisableAllActionButtons: excludedReviewersList.some(
            (id: any) => id === user.identityUserInfo.internalUserID
          ),
        }}
        sectionProps={this.handleUpdateProcedureProcessSectionProps()}
        savedInProps={this.handleUpdateProcedureProcessSavedInProps()}
        serverPathProps={this.handleUpdateProcedureProcessServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        params={{
          ...this.handleUpdateProcedureProcessParams(),
          // @ts-ignore
          CategoryID: this.categoryID,
          // @ts-ignore
          AccountID: this.accountID,
          // @ts-ignore
          TaskGroupID: this.taskGroupID,
          // @ts-ignore
          TaskLabelID: this.taskLabelID,
        }}
        data={procedureTableData}
        shareTaskData={shareTaskData}
        procedureRef={procedureRef}
        revisionInfoRef={revisionInfoRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        updateFileNumLoading={this.updateFileNumLoading}
        revisionInfoData={revisionInfoState}
        returnFileDataValue={(this as any).returnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        closePage={this.closePage}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        levelCRef={levelCRef}
        supportingTableData={supportingTableData}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
        isLevelCChange={(this as any).isLevelCChange}
      />
    );
  };

  handleUpdateProcedureProcessApproveUpdateProcedureComplete = (
    procedureTableData: any,
    newRejectReason: any
  ) => {
    const { shareTaskData, supportingTableData, revisionInfoState } = this.state;
    // @ts-ignore
    const isRejectCompletePage = this.actionID === actions.reject;

    return (
      // @ts-ignore
      <ApproveUpdateProcedureComplete
        ref={approvePageRef}
        approvePageRef={approvePageRef}
        pageProps={{
          ...this.handleUpdateProcedureProcessPageProps(),
          newRejectReason,
          // @ts-ignore
          actionID: this.actionID,
          isDisableAll: true,
        }}
        sectionProps={this.handleUpdateProcedureProcessSectionProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        data={procedureTableData}
        shareTaskData={shareTaskData}
        params={{
          ...this.handleUpdateProcedureProcessParams(),
          // @ts-ignore
          CategoryID: this.categoryID,
          // @ts-ignore
          AccountID: this.accountID,
          // @ts-ignore
          TaskGroupID: this.taskGroupID,
          // @ts-ignore
          TaskLabelID: this.taskLabelID,
        }}
        closePage={this.closePage}
        supportingTableData={supportingTableData}
        revisionInfoData={revisionInfoState}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        levelCRef={levelCRef}
        savedInProps={this.handleUpdateProcedureProcessSavedInProps()}
        serverPathProps={this.handleUpdateProcedureProcessServerPathProps()}
        revisionInfoRef={revisionInfoRef}
        _showLoading={this._showLoading}
        returnFileDataValue={(this as any).returnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        isLevelCChange={(this as any).isLevelCChange}
        _hideLoading={this._hideLoading}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
        isRejectCompletePage={isRejectCompletePage}
      />
    );
  };

  handleUpdateProcedureProcessSubmitUpdateProcedureComplete = (procedureTableData: any) => {
    const { shareTaskData, supportingTableData, revisionInfoState } = this.state;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      <SubmitUpdateProcedureComplete
        serverPathValue={serverPathValue}
        shareTaskData={shareTaskData}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        supportingTableData={supportingTableData}
        revisionInfoData={revisionInfoState}
        pageProps={this.handleUpdateProcedureProcessPageProps()}
        sectionProps={this.handleUpdateProcedureProcessSectionProps()}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
        params={this.handleUpdateProcedureProcessParams()}
      />
    );
  };

  render() {
    const { loading, procedureStepStatus, rejectReason } = this.state.pageState;

    const procedureTableData = JSON.parse(JSON.stringify(this.state.fileTableData));

    // @ts-ignore
    const isApprovePendingPage = this.isApprovePage && procedureStepStatus === "Pending";
    // @ts-ignore
    const isApproveCompletePage = this.isApprovePage && procedureStepStatus === "Complete";
    // @ts-ignore
    const isRevisePendingPage = this.isRevisePage && procedureStepStatus === "Pending";
    // @ts-ignore
    const isReviseCompletePage =
      this.isRevisePage && procedureStepStatus === "Complete" && this.triggerTimes > 1;
    // @ts-ignore
    const isSubmitCompletePage =
      this.isRevisePage && procedureStepStatus === "Complete" && this.triggerTimes === 1;
    const newRejectReason = rejectReason;

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          this.state.fileLoading.allNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {this.state.fileLoading.currentNum}/{this.state.fileLoading.allNum} file
            </p>
          ) : undefined
        }
      >
        <>
          {isRevisePendingPage &&
            this.handleUpdateProcedureProcessReviseUpdateProcedurePending(procedureTableData)}
          {isReviseCompletePage &&
            this.handleUpdateProcedureProcessReviseUpdateProcedureComplete(procedureTableData)}
          {isApprovePendingPage &&
            this.handleUpdateProcedureProcessApproveUpdateProcedurePending(
              procedureTableData,
              newRejectReason
            )}

          {isApproveCompletePage &&
            this.handleUpdateProcedureProcessApproveUpdateProcedureComplete(
              procedureTableData,
              newRejectReason
            )}

          {isSubmitCompletePage &&
            this.handleUpdateProcedureProcessSubmitUpdateProcedureComplete(procedureTableData)}
        </>
      </NormalSpin>
    );
  }
}
